import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../../src/PageHeader/PageHeader.docs.json';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {PageHeader} from '@primer/react/drafts'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Has title only`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.TitleArea>
    <PageHeader.Title>Title</PageHeader.Title>
  </PageHeader.TitleArea>
</PageHeader>
`}</code></pre>
    <h3>{`Title `}<inlineCode parentName="h3">{`variant="large"`}</inlineCode></h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.TitleArea variant="large">
    <PageHeader.Title>Title</PageHeader.Title>
  </PageHeader.TitleArea>
</PageHeader>
`}</code></pre>
    <h3>{`With leading and trailing visuals`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.TitleArea>
    <PageHeader.LeadingVisual>
      <GitPullRequestIcon />
    </PageHeader.LeadingVisual>
    <PageHeader.Title>Title</PageHeader.Title>
    <PageHeader.TrailingVisual>
      <Label>Beta</Label>
    </PageHeader.TrailingVisual>
  </PageHeader.TitleArea>
</PageHeader>
`}</code></pre>
    <h3>{`With leading visual is hidden on regular viewport`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.TitleArea>
    <PageHeader.LeadingVisual hidden={{regular: true}}>
      <GitPullRequestIcon />
    </PageHeader.LeadingVisual>
    <PageHeader.Title>Title</PageHeader.Title>
    <PageHeader.TrailingVisual>
      <Label>Beta</Label>
    </PageHeader.TrailingVisual>
  </PageHeader.TitleArea>
</PageHeader>
`}</code></pre>
    <h3>{`With leading and trailing actions`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.TitleArea>
    <PageHeader.LeadingAction>
      <IconButton aria-label="Expand" icon={SidebarExpandIcon} variant="invisible" />
    </PageHeader.LeadingAction>
    <PageHeader.Title>Title</PageHeader.Title>
    <PageHeader.TrailingAction>
      <IconButton aria-label="Edit" icon={PencilIcon} variant="invisible" />
    </PageHeader.TrailingAction>
  </PageHeader.TitleArea>
</PageHeader>
`}</code></pre>
    <h3>{`With actions`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.TitleArea>
    <PageHeader.Title>Title</PageHeader.Title>
    <PageHeader.Actions>
      <IconButton aria-label="Workflows" icon={WorkflowIcon} />
      <IconButton aria-label="Insights" icon={GraphIcon} />
      <Button variant="primary" trailingIcon={TriangleDownIcon}>
        Add Item
      </Button>
      <IconButton aria-label="Settings" icon={GearIcon} />
    </PageHeader.Actions>
  </PageHeader.TitleArea>
</PageHeader>
`}</code></pre>
    <h3>{`With description slot`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.TitleArea>
    <PageHeader.Title>add-pageheader-docs</PageHeader.Title>
  </PageHeader.TitleArea>
  <PageHeader.Description>
    <Text sx={{fontSize: 1, color: 'fg.muted'}}>
      <Link href="#" muted sx={{fontWeight: 'bold'}}>
        broccolinisoup
      </Link>{' '}
      created this branch 5 days ago · 14 commits · updated today
    </Text>
  </PageHeader.Description>
</PageHeader>
`}</code></pre>
    <h3>{`With navigation slot`}</h3>
    <h4>{`Utilizing a Navigation component`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.TitleArea>
    <PageHeader.Title>Pull request title</PageHeader.Title>
  </PageHeader.TitleArea>
  <PageHeader.Navigation>
    <UnderlineNav2 aria-label="Pull Request">
      <UnderlineNav2.Item icon={CommentDiscussionIcon} counter="12" aria-current="page">
        Conversation
      </UnderlineNav2.Item>
      <UnderlineNav2.Item counter={3} icon={CommitIcon}>
        Commits
      </UnderlineNav2.Item>
      <UnderlineNav2.Item counter={7} icon={ChecklistIcon}>
        Checks
      </UnderlineNav2.Item>
      <UnderlineNav2.Item counter={4} icon={FileDiffIcon}>
        Files Changes
      </UnderlineNav2.Item>
    </UnderlineNav2>
  </PageHeader.Navigation>
</PageHeader>
`}</code></pre>
    <h4>{`Utilizing a custom navigation`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.TitleArea>
    <PageHeader.Title>Page Title</PageHeader.Title>
  </PageHeader.TitleArea>
  <PageHeader.Navigation as="nav" aria-label="Item list">
    <Box as="ul" sx={{display: 'flex', gap: '8px', listStyle: 'none', paddingY: 0, paddingX: 3}} role="list">
      <li>
        <Link href="#" aria-current="page">
          Item 1
        </Link>
      </li>
      <li>
        <Link href="#">Item 2</Link>
      </li>
    </Box>
  </PageHeader.Navigation>
</PageHeader>
`}</code></pre>
    <h3>{`With ContextArea`}</h3>
    <h4>{`With parent link and actions (only visible on mobile)`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.ContextArea>
    <PageHeader.ParentLink href="http://github.com">Parent Link</PageHeader.ParentLink>

    <PageHeader.ContextAreaActions>
      <Button size="small" leadingIcon={GitBranchIcon}>
        Main
      </Button>
      <IconButton size="small" aria-label="More Options" icon={KebabHorizontalIcon} />
    </PageHeader.ContextAreaActions>
  </PageHeader.ContextArea>
  <PageHeader.TitleArea>
    <PageHeader.Title>Title</PageHeader.Title>
  </PageHeader.TitleArea>
</PageHeader>
`}</code></pre>
    <h4>{`With context bar and actions (only visible on mobile)`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.ContextArea>
    <PageHeader.ContextBar>
      <Breadcrumbs>
        <Breadcrumbs.Item href="#">...</Breadcrumbs.Item>
        <Breadcrumbs.Item href="#">primer</Breadcrumbs.Item>
        <Breadcrumbs.Item href="#">react</Breadcrumbs.Item>
        <Breadcrumbs.Item href="#">src</Breadcrumbs.Item>
        <Breadcrumbs.Item href="#">PageHeader</Breadcrumbs.Item>
        <Breadcrumbs.Item href="#">PageHeader.tsx</Breadcrumbs.Item>
      </Breadcrumbs>
    </PageHeader.ContextBar>

    <PageHeader.ContextAreaActions>
      <Button size="small" leadingIcon={GitBranchIcon}>
        Main
      </Button>
      <IconButton size="small" aria-label="More Options" icon={KebabHorizontalIcon} />
    </PageHeader.ContextAreaActions>
  </PageHeader.ContextArea>
  <PageHeader.TitleArea>
    <PageHeader.Title>Title</PageHeader.Title>
  </PageHeader.TitleArea>
</PageHeader>
`}</code></pre>
    <h4>{`With a ContextArea with all possible children (always visible)`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.ContextArea hidden={false}>
    <PageHeader.ParentLink href="http://github.com" hidden={false}>
      Parent Link
    </PageHeader.ParentLink>

    <PageHeader.ContextBar hidden={false}>
      <Breadcrumbs>
        <Breadcrumbs.Item href="#">...</Breadcrumbs.Item>
        <Breadcrumbs.Item href="#">primer</Breadcrumbs.Item>
        <Breadcrumbs.Item href="#">react</Breadcrumbs.Item>
        <Breadcrumbs.Item href="#">src</Breadcrumbs.Item>
        <Breadcrumbs.Item href="#">PageHeader</Breadcrumbs.Item>
        <Breadcrumbs.Item href="#">PageHeader.tsx</Breadcrumbs.Item>
      </Breadcrumbs>
    </PageHeader.ContextBar>

    <PageHeader.ContextAreaActions hidden={false}>
      <Button size="small" leadingIcon={GitBranchIcon}>
        Main
      </Button>
      <IconButton size="small" aria-label="More Options" icon={KebabHorizontalIcon} />
    </PageHeader.ContextAreaActions>
  </PageHeader.ContextArea>
  <PageHeader.TitleArea>
    <PageHeader.Title>Title</PageHeader.Title>
  </PageHeader.TitleArea>
</PageHeader>
`}</code></pre>
    <h3>{`With actions that have responsive content`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.TitleArea>
    <PageHeader.Title as="h2">Webhooks</PageHeader.Title>
    <PageHeader.Actions>
      <Hidden on={['narrow']}>
        <Button variant="primary">New webhook</Button>
      </Hidden>
      <Hidden on={['regular', 'wide']}>
        <Button variant="primary">New</Button>
      </Hidden>
    </PageHeader.Actions>
  </PageHeader.TitleArea>
</PageHeader>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: false,
      usedInProduction: false,
      usageExamplesDocumented: false,
      hasStorybookStories: false,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      